import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import AuthApiService from '../../../services/AuthApiService';
import { PageHeader, Card, Button, Field, Input } from '../../ui';

const ChangePassword = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const set = (k) => (e) => { setForm((p) => ({ ...p, [k]: e.target.value })); setError(''); };

  const validate = () => {
    if (!form.currentPassword || !form.newPassword || !form.confirmPassword) return 'All fields are required';
    if (form.newPassword.length < 6) return 'New password must be at least 6 characters';
    if (form.newPassword !== form.confirmPassword) return 'New password and confirmation do not match';
    if (form.currentPassword === form.newPassword) return 'New password must differ from the current one';
    return null;
  };

  const submit = async (e) => {
    e.preventDefault();
    const v = validate();
    if (v) return setError(v);
    setLoading(true);
    setError('');
    try {
      const res = await AuthApiService.changePassword(form.currentPassword, form.newPassword);
      if (res.success) {
        swal({ title: 'Success!', text: 'Password changed.', icon: 'success', button: 'OK' })
          .then(() => navigate('/stream-dashboard'));
      } else {
        setError(res.error || 'Failed to change password');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'An error occurred while changing password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tw-mx-auto tw-max-w-lg">
      <PageHeader title="Change Password" subtitle="Update the password for your account" />
      <Card>
        {error && (
          <div className="tw-mb-4 tw-rounded-lg tw-border tw-border-live/30 tw-bg-live/10 tw-px-3 tw-py-2 tw-text-sm tw-text-live">{error}</div>
        )}
        <form onSubmit={submit} className="tw-space-y-4">
          <Field label="Current password" required>
            <Input type="password" value={form.currentPassword} onChange={set('currentPassword')} placeholder="Enter current password" />
          </Field>
          <Field label="New password" required hint="At least 6 characters.">
            <Input type="password" value={form.newPassword} onChange={set('newPassword')} placeholder="Enter new password" />
          </Field>
          <Field label="Confirm new password" required>
            <Input type="password" value={form.confirmPassword} onChange={set('confirmPassword')} placeholder="Re-enter new password" />
          </Field>
          <div className="tw-flex tw-gap-2 tw-pt-2">
            <Button type="submit" icon={loading ? 'fa-spinner fa-spin' : 'fa-key'} disabled={loading}>
              {loading ? 'Changing…' : 'Change Password'}
            </Button>
            <Button type="button" variant="secondary" onClick={() => navigate('/stream-dashboard')} disabled={loading}>Cancel</Button>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default ChangePassword;
